








import { Component, Vue, Emit } from 'vue-property-decorator'
import { mapData } from '@/api/home'
import { getLocalItem } from '@/utils'
import axios from 'axios'
import ConsumptionSanking from '../ConsumptionSanking.vue'
const echarts = require('echarts')
@Component({
  name: 'mapChart',
})
export default class EnergySaving extends Vue {
  private chartsData: any = [];
  private myCharts: any;
  private provinces: any = {
    //23个省
    台湾省: 'taiwan',
    河北省: 'hebei',
    山西省: 'shanxi',
    辽宁省: 'liaoning',
    吉林省: 'jilin',
    黑龙江省: 'heilongjiang',
    江苏省: 'jiangsu',
    浙江省: 'zhejiang',
    安徽省: 'anhui',
    福建省: 'fujian',
    江西省: 'jiangxi',
    '370000': 'shandong',
    河南省: 'henan',
    湖北省: 'hubei',
    湖南省: 'hunan',
    广东省: 'guangdong',
    海南省: 'hainan',
    四川省: 'sichuan',
    贵州省: 'guizhou',
    云南省: 'yunnan',
    陕西省: 'shanxi1',
    甘肃省: 'gansu',
    青海省: 'qinghai',
    //5个自治区
    新疆维吾尔自治区: 'xinjiang',
    广西壮族自治区: 'guangxi',
    内蒙古自治区: 'neimenggu',
    宁夏回族自治区: 'ningxia',
    西藏自治区: 'xizang',
    //4个直辖市
    北京市: 'beijing',
    天津市: 'tianjin',
    上海市: 'shanghai',
    重庆市: 'chongqing',
    //2个特别行政区
    香港特别行政区: 'xianggang',
    澳门特别行政区: 'aomen',
  };
  private oroptionmapjsonr: any = {};
  handleProvinceChange(value: any) {
    var _this = this
    var params = ''
    if (this.provinces.hasOwnProperty(value)) {
      axios
        .get(
          'https://ybpt-public.obs.cn-north-4.myhuaweicloud.com/EnergyGovMap/province/' +
            this.provinces[value] +
            '.json'
        )
        .then((data) => {
          echarts.registerMap(value, data.data)
          var d = []
          for (var i = 0; i < data.data.features.length; i++) {
            d.push({
              name: data.data.features[i].properties.name,
              id: data.data.features[i].id,
            })
          }
          this.renderMap(value, d)
        })
    } else {
      axios
        .get(
          'https://ybpt-public.obs.cn-north-4.myhuaweicloud.com/EnergyGovMap/city/' +
            value +
            '.json'
        )
        .then((data) => {
          echarts.registerMap(value, data.data)
          mapData({
            regionCode: this.client.custRegionCode,
          }).then((res) => {
            // this.chartsData = res.data.map((item: any) => {
            //   return {
            //     name: item.regionName,
            //     value: item.comprehensiveEnergyConsumption,
            //   }
            // })
            this.chartsData = res.data
            this.chartsData.forEach((item :any) =>{
                item.name = item.regionName
                item.value = item.comprehensiveEnergyConsumption?item.comprehensiveEnergyConsumption.toFixed(2):''
            })
            this.renderMap(value, this.chartsData)
          })
        })
    }
  }
  renderMap(map: any, data1: any) {
    const main = document.getElementById('mapChart')
    const chart1 = echarts.init(main as HTMLDivElement)
    this.oroptionmapjsonr.geo = [
    //   {
    //     map: map,
    //     aspectScale: 0.9,
    //     selectedMode: 'single',
    //     roam: false, //是否允许缩放
    //     //zoom: 1.1, //默认显示级别
    //     layoutSize: '95%',
    //     layoutCenter: ['50%', '50%'],
    //     regions: data1,
    //     itemStyle: {
    //       areaColor: 'transparent',
    //       borderColor: '#37C1FD',
    //       borderWidth: 2,
    //     },
    //     normal: {
    //       show: true,
    //       textStyle: {
    //         color: '#fff',
    //         fontSize: 13,
    //       },
    //     },
    //     select: {
    //       label: {
    //         show: true,
    //         areaColor: '#fff',
    //         fontSize: 16,
    //         color: '#fff',
    //         formatter: function (params: any) {
    //           return params.name
    //         },
    //       },
    //       itemStyle: {
    //         color: '#fff',
    //         areaColor: '#5b8bed',
    //       },
    //     },
    //     // emphasis: {
    //     //   show: true,
    //     //   itemStyle: {
    //     //     areaColor: '#0160AD',
    //     //     textStyle: {
    //     //       color: '#000',
    //     //       fontSize: 15,
    //     //     },
    //     //   },
    //     //   label: {
    //     //     show: true,
    //     //     color: '#fff',
    //     //     textStyle: {
    //     //       color: '#fff',
    //     //       fontSize: 15,
    //     //     },
    //     //   },
    //     // },
    //     zlevel: 0,
    //   },
    //   {
    //     map: map,
    //     aspectScale: 0.9,
    //     roam: false, //是否允许缩放
    //     //zoom: 1.1, //默认显示级别
    //     layoutSize: '95%',
    //     geoIndex: 0,
    //     layoutCenter: ['50%', '50%'],
    //     label: {
    //       normal: {
    //         show: true,
    //         textStyle: {
    //           color: '#fff',
    //           fontSize: 13,
    //         },
    //       },
    //       emphasis: {
    //         show: true,
    //         textStyle: {
    //           color: '#fff',
    //           fontSize: 15,
    //         },
    //       },
    //     },
    //     itemStyle: {
    //       areaColor: {
    //         type: 'radial',
    //         x: 0.7,
    //         y: 0.5,
    //         r: 0.4,
    //         colorStops: [
    //           {
    //             offset: 0,
    //             color: '#56CCFB', // 0% 处的颜色
    //           },
    //           {
    //             offset: 1,
    //             color: '#0160AD', // 100% 处的颜色
    //           },
    //         ],
    //         global: false, // 缺省为 false
    //       },
    //       borderColor: '#37C1FD',
    //       borderWidth: 2,
    //     },
    //     zlevel: 2,
    //     silent: true,
    //     regions: data1,
    //   },
    //   {
    //     map: map,
    //     aspectScale: 0.9,
    //     roam: false, //是否允许缩放
    //     //zoom: 1.1, //默认显示级别
    //     layoutSize: '95%',
    //     layoutCenter: ['50%', '52%'],
    //     itemStyle: {
    //       areaColor: '#005DDC',
    //       borderColor: '#329BF5',
    //       borderWidth: 1,
    //     },
    //     zlevel: 1,
    //     silent: true,
    //     data: data1,
    //     regions: data1,
    //   },
    ]
    this.oroptionmapjsonr.series = [
      {
        name: map,
        type: 'map',
        aspectScale: 0.9,
        mapType: map,
        roam: false,
        nameMap: {
          china: '中国',
        },
        label: {
          normal: {
            show: true,
            textStyle: {
              color: '#fff',
              fontSize: 13,
            },
          },
          emphasis: {
            show: true,
            textStyle: {
              color: '#fff',
              fontSize: 13,
            },
          },
        },
        zoom: 1.2,
                emphasis: {
                      areaColor: '#3066ba',//鼠标滑过区域颜色
          show: true,
          itemStyle: {
            areaColor: '#0160AD',
            textStyle: {
              color: '#000',
              fontSize: 15,
            },
          },
        //   label: {
        //     show: true,
        //     color: '#fff',
        //     textStyle: {
        //       color: '#fff',
        //       fontSize: 15,
        //     },
        //   },
        },
       itemStyle: {
          areaColor: {
            type: 'radial',
            x: 0.7,
            y: 0.5,
            r: 0.4,
            colorStops: [
              {
                offset: 0,
                color: '#56CCFB', // 0% 处的颜色
              },
              {
                offset: 1,
                color: '#0160AD', // 100% 处的颜色
              },
            ],
            global: false, // 缺省为 false
          },
          borderColor: '#37C1FD',
          borderWidth: 2,
        },
        data: data1,
      },
    ]
    this.oroptionmapjsonr.tooltip = {
      formatter(params: any) {
        if(params.value){
            return params.name + ':' + params.value
        }else{
            return params.name
        }
      },
    }

    // 渲染地图
    chart1.setOption(this.oroptionmapjsonr)
    //地图点击事件---高亮
    chart1.on('click', (param: any) => {
      if (param.data) {
        this.cllbanck(param.data)
      }
    })
  }
  @Emit('cllbanck')
  cllbanck(param: any) {
    return param
  }
    nomole(e:any){
        const main = document.getElementById('mapChart')
        const chart1 = echarts.init(main as HTMLDivElement)
        this.chartsData.forEach((item:any) => {
        setTimeout(() => {
            chart1.dispatchAction({
            type: 'unselect',
            name:item.name
            })
        }, 0)
        })
    }
  private client: any = getLocalItem('client');
  created() {
    this.handleProvinceChange(this.client.custRegionCode)
  }
}
